/**
 * @module
 * @format
 */

import {service} from 'nova';
import {parseScriptElementAsJson} from '@acng/frontend-bounty/parse.js';
import {assign} from '@acng/frontend-bounty/object.js';
import {guard, asPortalData} from 'acng/model';

/**
 * @import {user} from './user/user.js';
 */

/**
 * Provide basic portal information.
 */
@service
class Portal {
  /**
   * @deprecated Use {@link user.niche}
   */
  niche;

  /**
   * @deprecated Use {@link user.list_sorting_suffix}
   */
  list_sorting_suffix;

  /**
   * @deprecated Use {@link user.international} or {@link user.domestic}
   */
  is_international;

  /**
   * @deprecated Use {@link user.fsk}
   */
  guest_fsk;

  /**
   * @deprecated Use {@link user.getListFsk}
   */
  list_base_fsk;

  constructor() {
    /**
     * "Extend" the data object after validation.
     */
    const data = parseScriptElementAsJson('portal');

    ASSERT: {
      guard(data, asPortalData);

      /**
       * Every portal has a {@link Portal.mobile} variant with a different `id`.
       *
       * @example 10002
       */
      this.id = data.id;

      /**
       * @example 'Sexpartner Community'
       */
      this.name = data.name;

      /**
       * @example 'spc'
       */
      this.abbr = data.abbr;

      /**
       * @deprecated
       * @example 'SPC'
       *
       * @see {@link Portal.abbr}
       */
      this.shortcut = data.shortcut;

      /**
       * The portal variant (mobile/desktop) is selected in the backend, depending on the user agent.
       */
      this.mobile = data.mobile;

      /**
       * @example © 2026 Sexpartner Community
       */
      this.copyrightNotice = data.copyrightNotice;
      this.script = data.script;
      this.email = data.email;
      this.link = data.link;

      this.niche = data.niche;
      this.list_sorting_suffix = data.list_sorting_suffix;
      this.is_international = data.is_international;
      this.guest_fsk = data.guest_fsk;
      this.list_base_fsk = data.list_base_fsk;
    }

    assign(this, data);

    this.mailto = {
      support: `mailto:${data.email.support}`,
      compliance: `mailto:${data.email.compliance}`,
    };
  }
}

export {Portal};
